<template>
    <div class="LuaEditor" :class="{disabled: !editable}">
        <textarea v-model="itemInner.script" @focusout="save" ref="textarea" :disabled="!editable"></textarea>
    </div>
</template>

<script>

export default {
    name: "LuaEditor",
    props: {
        item: Object,
        editable: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            itemInner: null,
            editor: null
        }
    },
    mounted() {
        this.initLuaEditor()
    },
    methods: {
        save() {
            if (JSON.stringify(this.item) !== JSON.stringify(this.itemInner)) {
                this.$emit('update:item', this.itemInner)
                this.$emit('save')
            }
        },
        initLuaEditor() {
            let textarea = this.$refs.textarea
            let editor = window.CodeMirror.fromTextArea(textarea, {
                styleActiveLine: true,
                matchBrackets: true,
                theme: 'default',
                autoRefresh: true,
                lineNumbers: true,
                mode: 'lua',
                readOnly: !this.editable
            });
            editor.on('blur', instance => {
                this.itemInner.script = instance.getValue()
                this.save()
            })
            this.editor = editor
        }
    },
    watch: {
        item: {
            deep: true,
            immediate: true,
            handler: function (item) {
                this.itemInner = item ? JSON.parse(JSON.stringify(item)) : null
                this.$nextTick(() => {
                    this.editor.getDoc().setValue(this.itemInner.script)
                })
            }
        },
        editable: function (newVal) {
            this.$nextTick(() => {
                this.editor.setOption('readOnly', !newVal)
            })
        }
    }
}
</script>

<style scoped lang="scss">
.LuaEditor {
    border: 1px solid #ddd;
}

::v-deep {
    .CodeMirror-hscrollbar, .CodeMirror-vscrollbar {
        &::-webkit-scrollbar {
            width: 7px;
            height: 7px;
            background-color: transparent;
            border: none;
        }

        &::-webkit-scrollbar-track {
            background-color: transparent;
            border: none;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: rgba(0, 0, 0, 0.1);
            border: none;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: rgba(0, 0, 0, 0.5);
        }
    }
}
</style>
